"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _angieslistReactComponents = require("angieslist-react-components");
require("./ratingDistribution.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var RatingDistribution = function RatingDistribution(_ref) {
  var _context;
  var ratingsDistribution = _ref.ratingsDistribution,
    title = _ref.title,
    customClass = _ref.customClass,
    customId = _ref.customId,
    ratingDistributionNumberLocation = _ref.ratingDistributionNumberLocation;
  var objectKeys = [5, 4, 3, 2, 1];
  var distributionObj = (0, _reduce["default"])(objectKeys).call(objectKeys, function (obj, key) {
    return _objectSpread(_objectSpread({}, obj), {}, (0, _defineProperty2["default"])({}, key, ratingsDistribution[key] || 0));
  }, {});
  var distributionTotal = (0, _reduce["default"])(_context = (0, _values["default"])(distributionObj)).call(_context, function (a, b) {
    return a + b;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: customClass,
    id: customId,
    "aria-label": "rating-distribution-".concat(customId)
  }, /*#__PURE__*/React.createElement("p", {
    className: "rating-distribution-title"
  }, title), (0, _map["default"])(objectKeys).call(objectKeys, function (key) {
    var percentage = distributionTotal !== 0 ? distributionObj[key] / distributionTotal * 100 : 0;
    return /*#__PURE__*/React.createElement("div", {
      className: "rating-distribution",
      key: "rating-distribution--".concat(key),
      "aria-label": "rating-distribution-".concat(key)
    }, ratingDistributionNumberLocation !== 'right' ? /*#__PURE__*/React.createElement("span", {
      className: "rating-distribution-number"
    }, /*#__PURE__*/React.createElement("p", null, key)) : null, /*#__PURE__*/React.createElement(_angieslistReactComponents.FullStar, {
      size: "1.2em"
    }), ratingDistributionNumberLocation === 'right' ? /*#__PURE__*/React.createElement("span", {
      className: "rating-distribution-number"
    }, /*#__PURE__*/React.createElement("p", null, key)) : null, /*#__PURE__*/React.createElement(_angieslistReactComponents.ProgressBar, {
      className: "rating-distribution-bar",
      now: percentage
    }), /*#__PURE__*/React.createElement("p", {
      className: "rating-distribution-value"
    }, distributionObj[key]));
  }));
};
RatingDistribution.propTypes = {
  ratingsDistribution: _propTypes["default"].shape({}),
  title: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  customId: _propTypes["default"].string,
  ratingDistributionNumberLocation: _propTypes["default"].string
};
RatingDistribution.defaultProps = {
  ratingsDistribution: {},
  title: '',
  customId: '',
  customClass: '',
  ratingDistributionNumberLocation: ''
};
var _default = exports["default"] = RatingDistribution;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/ratings/ratingDistribution.js
// module id = 6389
// module chunks = 25